import React, { useContext } from 'react';
import { styled, css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { ProfileLink } from '@confluence/profile/entry-points/ProfileLinkComponent';

import { PageCardContext } from '../PageCardContext';

const linkStyle = css({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	a: {
		color: 'var(--secondary-text-color)',
		fontWeight: token('font.weight.regular'),
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		'&:active, &:visited, &:hover, &:focus': {
			color: 'var(--secondary-text-color)',
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AuthorContainer = styled.div<{ compact?: boolean }>(
	{
		zIndex: 0,
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		display: 'flex',
		alignItems: 'center',
		font: token('font.body.UNSAFE_small'),
		color: token('color.text.subtle'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) =>
		props.compact
			? `
      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
      }
    `
			: ``,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	linkStyle,
);

export const Author = () => {
	const pageCard = useContext(PageCardContext);

	if ('history' in pageCard && 'creatorId' in pageCard) {
		const hasAuthor = pageCard.history?.ownedBy?.displayName;
		return hasAuthor ? (
			<AuthorContainer>
				<ProfileLink
					userId={pageCard.creatorId}
					fullName={pageCard.history.ownedBy.displayName}
					referralSource="pageCard"
				/>
			</AuthorContainer>
		) : null;
	}

	if ('createdBy' in pageCard) {
		const hasAuthor = pageCard.createdBy?.displayName;
		return hasAuthor ? (
			<AuthorContainer>
				<ProfileLink
					userId={pageCard.createdBy.accountId}
					fullName={pageCard.createdBy.displayName}
					referralSource="pageCard"
				/>
			</AuthorContainer>
		) : null;
	}

	return null;
};
